import { Component, Input,  } from '@angular/core';
@Component({
  selector: 'crem-dropdown',
  template: `
   <div class="dx-fieldset">
    <div class="dx-field">
        <div [style.width]="width" class="dx-field-value">
            <dx-select-box #selectBox  [items]="items" [value]="items[0]" [disabled]="disabled" [placeholder]="placeholder">
            </dx-select-box>
        </div>
    </div>
</div>
  `,
  styleUrls: ['dropdown.component.scss']
})
export class DropdownComponent {


  @Input()
  public placeholder:string;

  @Input()
  public disabled:boolean;

  @Input()
  public width:string;

  @Input()
  public items: any;

}
